import { QuestContext, QuestContextType } from '@src/providers/quest';
import { useContext } from 'react';

export const useDappState = (): QuestContextType => {
  const ctx = useContext(QuestContext);

  return {
    partBalance: ctx?.partBalance,
    parcBalance: ctx?.parcBalance,
    account: ctx?.account,
    connect: ctx?.connect,
    connectError: ctx?.connectError,
    connectLoading: ctx?.connectLoading,
    isConnected: ctx?.isConnected,
    isPuzzleWalletWebview: ctx?.isPuzzleWalletWebview,
    isPro: ctx?.isPro,
  };
};
